import React, { useState, useEffect, createContext, useContext } from 'react';
import { auth } from './firebase';

const authContext = createContext();

const useAuthProvider = () => {
  const [user, setUser] = useState(null);
  const [userIsLoading, setUserIsLoading] = useState(false);

  const signup = (email, password) => {
    return auth
      .createUserWithEmailAndPassword(email, password)
      .then((response) => {
        setUser(response.user);
        return response.user;
      });
  };

  const signin = (email, password) => {
    return auth.signInWithEmailAndPassword(email, password).then((response) => {
      setUser(response.user);
      return response.user;
    });
  };

  const signout = () => {
    return auth.signOut().then(() => {
      setUser(false);
    });
  };

  const resetPassword = (email) => {
    return auth.sendPasswordResetEmail(email);
  };

  useEffect(() => {
    setUserIsLoading(true);
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUser(user);
        setUserIsLoading(false);
      } else {
        setUser(false);
        setUserIsLoading(false);
      }
    });

    return unsubscribe;
  }, []);

  return {
    user,
    userIsLoading,
    signup,
    signin,
    signout,
    resetPassword,
  };
};

export const AuthProvider = ({ children }) => {
  const auth = useAuthProvider();
  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
};

export const useAuth = () => {
  return useContext(authContext);
};
